import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";

export function MarketingPreferences() {
  const { user, setUser } = useAuth();
  const [subscribed, setSubscribed] = useState(
    Boolean(user?.email_marketing_opt_in && user?.sms_marketing_opt_in),
  );
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setSubscribed(Boolean(user?.email_marketing_opt_in && user?.sms_marketing_opt_in));
  }, [user?.email_marketing_opt_in, user?.sms_marketing_opt_in]);

  const updateSubscription = async (nextValue) => {
    const previousValue = subscribed;
    setSubscribed(nextValue);
    setSaving(true);
    try {
      const { data } = await api.put("/auth/marketing-preferences", {
        email_marketing_opt_in: nextValue,
        sms_marketing_opt_in: nextValue,
      });
      setUser({ ...user, ...data });
      toast.success(nextValue ? "Subscribed to marketing updates" : "Unsubscribed from marketing updates");
    } catch (error) {
      setSubscribed(previousValue);
      toast.error(formatApiError(error.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="mt-12 border-t border-neutral-200 pt-6" data-testid="marketing-preferences">
      <label className="inline-flex items-center gap-3 text-sm text-neutral-600">
        <Checkbox
          checked={subscribed}
          disabled={saving}
          onCheckedChange={(checked) => updateSubscription(checked === true)}
          data-testid="account-marketing-subscription"
        />
        Subscribe to marketing updates
      </label>
    </section>
  );
}